var exports = {
  "x": "xf61da738--f469c3--offer",
  "nV": "xf61da738--f469c3--gallery",
  "pq": "xf61da738--f469c3--info",
  "q9": "xf61da738--f469c3--price",
  "mW": "xf61da738--f469c3--one-line-text",
  "nf": "xf61da738--f469c3--link",
};

module.exports = exports;
